@if (loading()) {
  <span class="job-readiness-indicator" title="Checking job readiness…">
    <i class="fa fa-spinner fa-spin text-muted"></i>
  </span>
} @else if (visual(); as v) {
  <button
    type="button"
    class="job-readiness-indicator k-button-link"
    kendoTooltip
    [title]="tooltip()"
    (click)="openDialog()"
  >
    <i class="fas {{ v.icon }} {{ v.colorClass }}"></i>
  </button>
}

@if (dialogOpen()) {
  <kendo-dialog
    [width]="560"
    (close)="closeDialog()"
    class="job-readiness-dialog"
  >
    <kendo-dialog-titlebar>
      @if (visual(); as v) {
        <i class="fas {{ v.icon }} {{ v.colorClass }} me-2"></i>
      }
      <span>Job Readiness</span>
    </kendo-dialog-titlebar>

    <p class="text-muted mb-3">
      Setup checks run at entry time so gaps surface here instead of at export.
      A red setup check will block export/batch-post until the job setup is
      fixed; keyed time itself stays editable until it exports. The labor check
      lists lines from the last 12 weeks: red lines the export will hold or fail
      (only those lines, the rest of the job still exports), orange lines worth
      checking.
    </p>

    <ul class="job-readiness-checks">
      @for (row of checkRows(); track row.check.CheckKey) {
        @let check = row.check;
        <li class="job-readiness-check">
          @if (row.visual; as cv) {
            <i class="fas {{ cv.icon }} {{ cv.colorClass }} check-icon"></i>
          }
          <div class="check-body">
            <div class="check-title">{{ row.label }}</div>
            <div class="check-message">{{ check.Message }}</div>
            @if (row.items.length) {
              <ul class="check-items">
                @for (entry of row.items; track entry.item.EmployeeLaborID) {
                  <li class="check-item">
                    <i
                      class="fas {{ entry.visual.icon }} {{
                        entry.visual.colorClass
                      }} item-icon"
                    ></i>
                    <div>
                      <div class="item-line">
                        {{ entry.item.Employee }} &middot;
                        {{ entry.item.DateWorked | date: 'M/d/yyyy' }} &middot;
                        {{ entry.item.Hours | number: '1.0-2' }} h &middot;
                        @if (timeSheetLinks() && entry.item.TimeSheetName) {
                          <button
                            type="button"
                            class="k-button-link item-timesheet"
                            (click)="openTimeSheet.emit(entry.item)"
                          >
                            {{ entry.item.TimeSheetName }}
                          </button>
                        } @else {
                          {{ entry.item.TimeSheetName }}
                        }
                        @if (entry.item.Exported) {
                          <span class="text-muted">(exported)</span>
                        }
                      </div>
                      <div class="item-label">{{ entry.item.Label }}</div>
                    </div>
                  </li>
                }
              </ul>
            }
            @if (check.MissingItems?.length) {
              <div class="check-missing">
                @for (item of check.MissingItems; track item) {
                  <span class="missing-item">{{ item }}</span>
                }
              </div>
            }
          </div>
        </li>
      }
    </ul>

    <kendo-dialog-actions>
      <button kendoButton (click)="closeDialog()">Close</button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
